import React, { useState, useEffect, useRef } from "react";
import '../../css/index.css';
import HttpService from "../../services/HttpService";
import Button from "../Tools/Components/Button";
import KvkOpt from "./Components/KvkOpt";
import { useTranslation } from 'react-i18next';

const CreditorPagina = () => {
    const axiosRef = useRef(null);
    const [creditor, setCreditor] = useState(null);
    const [editing, setEditing] = useState(false);
    const [creating, setCreating] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        const httpService = HttpService;
        httpService.configure();
        axiosRef.current = httpService.getAxiosClient();

        if (window.location.href.endsWith("create")) {
            setEditing(true);
            setCreating(true);
            setCreditor({
                emailVerzender: "",
                kvk: "",
                alias: "",
                zoekveld: "",
                kvkOptimalisaties: []
            });
            return;
        }

        const id = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
        if (Number.isNaN(Number.parseInt(id))) return;

        axiosRef.current.get(process.env.REACT_APP_INKOFACT_API_URL + "Klant/" + id)
            .then(response => { setCreditor(response.data); })
            .catch(ex => alert(ex));
    }, []);

    const createBtnHandler = () => {
        if (!axiosRef.current) return;
        const url = process.env.REACT_APP_INKOFACT_API_URL + "Klant/single";
        axiosRef.current.post(url, creditor)
            .then(response => window.location.href = "/FactuurKvk/" + response.data)
            .catch(ex => alert(ex));
    };

    const editBtnHandler = () => {
        if (!axiosRef.current) { alert("axios not yet loaded"); return; }
        const id = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
        if (Number.isNaN(Number.parseInt(id))) return;

        if (editing) {
            const url = process.env.REACT_APP_INKOFACT_API_URL + "Klant/" + id;
            axiosRef.current.put(url, creditor)
                .then(response => { window.location.reload(); })
                .catch(error => { alert(error); window.location.reload(); });
        }
        setEditing(!editing);
    };

    const addKvkOptBtnHandler = () => {
        if (!creditor) return;
        setCreditor(prev => ({
            ...prev,
            kvkOptimalisaties: [...prev.kvkOptimalisaties, { emailOntvanger: "", kvk: "" }]
        }));
    };

    const deleteKvkOptBtnHandler = (index) => {
        if (!creditor) return;
        setCreditor(prev => ({
            ...prev,
            kvkOptimalisaties: prev.kvkOptimalisaties.filter((_, i) => i !== index)
        }));
    };

    const deleteHandler = () => {
        if (!axiosRef.current) { alert("axios not yet loaded"); return; }
        const id = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
        if (Number.isNaN(Number.parseInt(id))) return;

        axiosRef.current.delete(process.env.REACT_APP_INKOFACT_API_URL + "Klant/" + id)
            .then(response => window.location.href = "/FactuurKvk")
            .catch(ex => alert(ex));
    };

    const setOneCreditorProperty = (propName, propVal) => {
        if (typeof propName !== "string") {
            alert("tried setting a prop on prompt opt with non string key. Key was: " + propName);
            return;
        }
        setCreditor(prev => ({ ...prev, [propName]: propVal }));
    };

    const setOneKvkOptProperty = (index, propName, val) => {
        if (typeof propName !== "string") {
            alert("tried setting a prop on prompt opt with non string key. Key was: " + propName);
            return;
        }

        setCreditor(prev => {
            const updatedKvkOptimalisaties = [...prev.kvkOptimalisaties];
            updatedKvkOptimalisaties[index] = { ...updatedKvkOptimalisaties[index], [propName]: val };
            return { ...prev, kvkOptimalisaties: updatedKvkOptimalisaties };
        });
    };

    const EditableField = (label, callBack, placeholder) => {
        return (
            <div className="content-stretch flex gap-[7px] items-center relative shrink-0 w-full">
                <label className="w-[215px] text-right font-bold">{label}:</label>
                <input
                    onChange={callBack}
                    className="bg-[#ffffff] bg-black-override h-[23px] relative shrink-0 w-[320px] absolute border border-black border-solid inset-0"
                    defaultValue={placeholder}
                    readOnly={!editing}
                />
            </div>
        );
    };

    const currentCreditor = creditor || { emailVerzender: "", alias: "", kvk: "", zoekveld: "", kvkOptimalisaties: [] };
    const kvkOptimalisaties = creditor?.kvkOptimalisaties || [];
    const updateFieldsButtonText = editing ? t("kvk.confirmBtn") : t("kvk.editBtn");
    const cancelEditButtonElement = editing ? (
        <Button text={t("kvk.cancelBtn")} onClick={() => window.location.reload()} />
    ) : null;

    return (
        <div className="relative size-full" data-name="Content Box">
            <div className="flex flex-col items-center max-w-inherit min-w-inherit size-full">
                <div className="box-border content-stretch flex flex-col items-center max-w-inherit min-w-inherit px-0 py-2 relative size-full">
                    {/* Header */}
                    <div className="bg-[#00aaad] dark:bg-[#008b8e] relative shrink-0 w-full" data-name="ContentBoxHeader">
                        <div aria-hidden="true" className="absolute border border-gray-400 border-solid inset-0 pointer-events-none" />
                        <div className="flex flex-col items-center justify-center size-full">
                            <div className="box-border content-stretch flex flex-col items-center justify-center px-[530px] py-[10px] relative w-full">
                                <div className="capitalize flex flex-col font-['Inter:Bold',sans-serif] font-bold justify-center leading-[0] not-italic relative shrink-0 text-[20px] text-center tracking-[-0.1px] w-[200px]">
                                    <p className="leading-[1.45]">{t("kvk.header")}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Main Content */}
                    <div className="bg-[rgba(243,244,246,0.75)] dark:bg-[rgba(55,65,81,0.75)] relative shrink-0 w-full min-h-[1000px]" data-name="Frame">
                        <div aria-hidden="true" className="absolute border border-gray-400 border-solid inset-0 pointer-events-none" />
                        <div className="size-full">
                            <div className="flex gap-[10px] items-start px-[28px] py-[10px] w-full">
                                {/* Left Column */}
                                <div className="flex-1">
                                    <div className="box-border gap-[10px] items-start px-[10px] relative shrink-0 flex flex-col">
                                        <div className="content-stretch flex flex-col gap-[20px] items-start relative shrink-0 w-full" data-name="Fields">
                                            {EditableField(t("kvk.sender"), (value) => setOneCreditorProperty("emailVerzender", value.target.value), currentCreditor.emailVerzender)}
                                            {EditableField(t("kvk.alias"), (value) => setOneCreditorProperty("alias", value.target.value), currentCreditor.alias)}
                                            {EditableField("KVK", (value) => setOneCreditorProperty("kvk", value.target.value), currentCreditor.kvk)}
                                            {EditableField(t("kvk.searchField"), (value) => setOneCreditorProperty("zoekveld", value.target.value), currentCreditor.zoekveld)}

                                            <div className="content-stretch flex flex-col gap-[2px] items-end relative shrink-0 w-full" data-name="Fields">
                                                <div className="content-stretch flex gap-[7px] items-center relative shrink-0 w-full">
                                                    <div className="w-full">{t("kvk.receiver")}</div>
                                                    <div className="w-full">kvk</div>
                                                </div>
                                                {kvkOptimalisaties.map((ko, index) => (
                                                    <KvkOpt
                                                        key={`${ko.id}`}
                                                        index={index}
                                                        kvkOpt={ko}
                                                        editing={editing}
                                                        onLeftChanged={(val) => setOneKvkOptProperty(index, "emailOntvanger", val)}
                                                        onRightChanged={(val) => setOneKvkOptProperty(index, "kvk", val)}
                                                        onDeletePressed={() => deleteKvkOptBtnHandler(index)}
                                                    />
                                                ))}
                                            </div>

                                            {editing && (
                                                <Button
                                                    text="+"
                                                    width="30"
                                                    height="30"
                                                    onClick={addKvkOptBtnHandler}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* Right Column */}
                                <div className="flex-1">
                                    <div className="basis-0 grow min-h-px min-w-[400px] relative shrink-0" data-name="RightCol">
                                        <div className="flex flex-col items-center min-w-inherit size-full">
                                            <div className="box-border content-stretch flex flex-col gap-[50px] items-center min-w-inherit px-[10px] py-0 relative w-full">
                                                {creating ? (
                                                    <div className="flex gap-[30px] w-full" data-name="buttons">
                                                        <Button text={t("kvk.createBtn")} onClick={createBtnHandler} />
                                                    </div>
                                                ) : (
                                                    <div className="flex gap-[30px] w-full" data-name="buttons">
                                                        <Button text={updateFieldsButtonText} onClick={editBtnHandler} />
                                                        {cancelEditButtonElement}
                                                        <Button text={t("kvk.deleteBtn")} onClick={deleteHandler} />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreditorPagina;
